//
//
//
//
//
//
//
//
//
//
//

import {baseURL} from 'service/config'
import {readCookie} from 'teld-web-component/lib/method'
import {GetRentPartnerList} from 'service/cmssg'
import { formatStandardTitle } from '@/utils/standard'
export default {
    data () {
        return {
            Attachment:baseURL.resourceAddr,
            width:""
        }
    },
    components: {
    },
    mounted () {
     this.width = Math.floor((($(window).width() - 30) * 0.72 - 20) / 6.5);
     this.init();
    //  document.title="租车列表";
     formatStandardTitle('租车列表')
    },
    methods: {
        init: function () {
            var _this =this;
            var postData = {
                "filter":JSON.stringify({
                    CityCode: this.$route.query.CityCode||readCookie('ta_cityCode'),
                    page: 1,
                    rows: 12
                })
            };
            GetRentPartnerList(postData,function (result) {
                if (result.state == 1) {
                    var data = result.data.rows;
                    if (data.length==0) {
                        var strHtm = '<div class="div-noCar"><img src="/static/original/img/PicActivity/station.png" /><p class="num1">暂无租车信息呀~</p><p class="num2">努力拓展中，敬请期待</p></div>';
                        $("#LsaseCarList").append(strHtm);
                    }
                    else {
                        for (var i = 0; i < data.length; i++) {
                            var imgurl = "";
                            if (data[i].ICon != null) {
                                if (data[i].ICon.toLowerCase().indexOf("teldimage") > -1) {
                                    imgurl = _this.Attachment + data[i].ICon;
                                } else {
                                    imgurl = data[i].ICon;
                                }
                            }
                            var str = '<a class="list-group-item" href="/module/Pictivity.html#/CarInfo?id=' + data[i].RPID + '">';
                            str += '<img src="' + imgurl + '" />';
                            str += '<div class="rightContent">';
                            str += '<h4>' + data[i].Title + '</h4>';
                            str += '<p class="CarlistP">'+data[i].Summary+'</p>';
                            str += '</div>';
                            str += '</a>';
                            $("#LsaseCarList").append(str);
                        }
                    }
                } else {
                    if (result.errcode == 402) {
                        var strHtm = '<div class="div-noCar"><img src="/static/original/img/PicActivity/station.png" /><p class="num1">暂无租车信息呀~</p><p class="num2">努力拓展中，敬请期待</p></div>';
                        $("#LsaseCarList").append(strHtm);
                    }
                }
            })
        },
        curt:function (data) {
            if (data.length > this.width) {
                var re = data.substring(0, this.width);
                if (re[width - 1] == "," || re[this.width - 1] == "，") {
                    re = re.substring(0, this.width - 1);
                }
                return re + "...";
            } else {
                return data;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/module/PicActivity/CarList.vue